import dayjs from "dayjs";

export const DateToShow = (date) => {
    return date == "0001-01-01T00:00:00" ? null : dayjs(date).format("DD-MM-YYYY")
};
